<script setup lang="ts">
import { prepareUrlInContent } from "~/modules/blog/helpers/prepareUrlInContent";
const props = defineProps<{
  content: string;
}>();

const { content } = toRefs(props);

const blogContent = computed<string | undefined>(() => {
  if (!content.value) return undefined;
  return prepareUrlInContent(content.value as string);
});
</script>

<template>
  <div class="cms-data-content" v-html="blogContent" />
</template>

<style lang="scss">
.cms-data-content {
  // a consumer may set `--cms-data-content-link-color` on any ancestor to
  // repaint the inline links without touching the rest of the typography,
  // see the blog post page
  --link-color: var(
    --cms-data-content-link-color,
    rgb(var(--colors-primary-700))
  );

  a {
    color: var(--link-color) !important;
    @apply hover:underline #{!important};
    span {
      color: var(--link-color) !important;
      @apply hover:underline #{!important};
    }
  }
  span {
    @apply text-neutral-500;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    @apply mt-4 font-bold text-neutral-900 first:mt-0 #{!important};

    span {
      @apply mt-4 font-bold text-neutral-900 first:mt-0 #{!important};
    }
  }

  p {
    @apply mb-3 py-3 text-base;
    &:has(strong) {
      @apply mb-3 mt-6 text-neutral-900 first:mt-0;
    }

    img {
      @apply my-7;
    }

    strong {
      span {
        @apply font-semibold text-neutral-900;
      }

      @apply font-semibold text-neutral-900;
      a {
        color: var(--link-color) !important;
      }
    }
  }

  ul {
    @apply mb-5 list-disc py-3 pl-4;

    li {
      @apply relative m-0 text-base text-neutral-500;
    }
  }

  ol {
    @apply mb-5 pl-4;
    li {
      @apply mb-3 text-base marker:text-lg marker:text-neutral-900;
    }
  }

  p,
  li {
    a {
      color: var(--link-color) !important;
    }
  }
  .image-style-align-left {
    @apply float-left m-0 mr-3;
  }
  .image-style-align-right {
    @apply float-right m-0 ml-3;
  }

  figure {
    @apply w-full #{!important};
  }
  table col {
    @apply max-md:w-full md:hidden #{!important};
  }
  tbody tr {
    @apply max-md:grid max-md:w-full;
  }
  tbody td {
    @apply align-top first:min-w-[60px] max-md:mt-6 md:pr-6 md:first:max-w-[350px];
    img {
      @apply h-full max-h-full w-full max-w-full object-cover #{!important};
    }
  }
}
</style>
